<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import HistoricalLogsTable from "@/components/Dashboard/Devices/HistoricalLogs/HistoricalLogsTable.vue";
</script>
<template>
  <ContentHeader :name="'Historical Logs'" />
  <HistoricalLogsTable />
</template>
